export default {
  icon_text: 'Cerrado',
  buttons: {
    ok: 'Aceptar',
  },
};
